/* Native cart forms remain functional without JavaScript. No theme cart hooks required. */
(() => {
  if (customElements.get('thq-sale-product')) return;
  class SaleProduct extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.addEventListener('change', event => {
        if (event.target.matches('[name="id"]')) this.update();
      });
      this.update();
    }
    update() {
      const control = this.querySelector('select[name="id"]');
      const choice = control ? control.selectedOptions[0] : this.querySelector('input[name="id"]:checked, input[type="hidden"][name="id"]');
      if (!choice) return;
      const price = this.querySelector('[data-sale-price]');
      const compare = this.querySelector('[data-sale-compare]');
      if (price && !this.hasAttribute('data-price-override')) price.textContent = choice.dataset.price || '';
      if (compare && !this.hasAttribute('data-compare-override')) {
        compare.textContent = choice.dataset.compare || '';
        compare.hidden = !choice.dataset.compare;
      }
      const image = this.querySelector('[data-sale-image]');
      if (image && choice.dataset.image && !this.hasAttribute('data-image-override')) {
        image.removeAttribute('srcset');
        image.src = choice.dataset.image;
        image.alt = choice.dataset.alt || '';
      }
      const link = this.querySelector('[data-sale-product-link]');
      if (link) {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', choice.value);
        link.href = url.toString();
      }
      const submit = this.querySelector('[data-sale-submit]');
      if (submit) {
        submit.disabled = choice.dataset.available !== 'true';
        submit.textContent = submit.disabled ? this.dataset.soldOut : this.dataset.cta;
      }
    }
  }
  customElements.define('thq-sale-product', SaleProduct);
})();
